import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
export default {
  name: "used-update",
  data: function data() {
    return {
      videoVisible: false,
      cityList: [],
      // 城市列表
      districtList: [],
      // 区域列表
      categoryList: [],
      // 分类列表

      uploadLoading: false,
      form: {
        imgs: [],
        cover: "",
        title: "",
        content: "",
        originalPrice: "",
        presentPrice: "",
        cityId: "",
        districtId: "",
        categoryId: ""
      },
      qiniuInitState: false,
      imageRotateDialogVisible: false,
      imageRotateUrl: "",
      imageRotateKey: ""
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getUsedCategoryList();
            _this.getCityList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  watch: {
    "form.url": function formUrl() {
      this.form.imgs.push(this.form.url);
    },
    "form.cityId": function formCityId() {
      this.getDistrictList(this.form.cityId);
    }
  },
  methods: {
    closeRotateDialog: function closeRotateDialog() {
      this.imageRotateDialogVisible = false;
    },
    saveRotateImgUrl: function saveRotateImgUrl(url) {
      this.form.imgs.splice(this.imageRotateKey, 1, url);
    },
    selectRotateImg: function selectRotateImg(key) {
      this.imageRotateKey = key || 0;
      this.imageRotateUrl = this.form.imgs[this.imageRotateKey];
      this.imageRotateDialogVisible = true;
    },
    getUsedCategoryList: function getUsedCategoryList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getUsedCategoryList();
            case 1:
              res = _context2.v;
              _this2.categoryList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getCityList: function getCityList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getUsedCityList();
            case 1:
              res = _context3.v;
              _this3.cityList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getDistrictList: function getDistrictList(cityId) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.getDistrictList({
                id: cityId
              });
            case 1:
              res = _context4.v;
              _this4.districtList = res.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getData: function getData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.getUsedInfo({
                id: _this5.$route.query.id
              });
            case 1:
              res = _context5.v;
              _this5.form = res.data;
              _this5.getDistrictList(_this5.form.cityId);
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    save: function save() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.updateUsed(_this6.form);
            case 1:
              _this6.$message.success("保存成功");

              // 操作上报
              _this6.$operationLog.push({
                code: 'save',
                userId: _this6.form.userId,
                operationType: "used",
                detailBatchNo: _this6.$route.query.id
              });
              _this6.$router.back();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    delImg: function delImg(index, img) {
      var _this7 = this;
      this.form.imgs.splice(index, 1);
      if (img == this.form.cover) {
        this.$nextTick(function () {
          _this7.form.cover = _this7.form.imgs[0];
        });
      }
    },
    selectVideoPreview: function selectVideoPreview() {
      var video = document.getElementById("J_video");
      var currentTime = Math.round(video.currentTime);
      this.form.cover = "".concat(this.form.video, "?vframe/jpg/offset/").concat(currentTime);
      this.form.video_cut_start_frame = currentTime;
      this.videoVisible = false;
    }
  }
};